<template>
  <div>
    <div class="graphic-details">
      <div
        class="graphic-info"
        v-if="productDetails"
        v-html="productMsg.content"
        style="width: 100%"
      ></div>
      <div class="no-msg" v-else>
        <img src="../image/Sj.png" alt="">
        <p>该商品暂无详情</p>
      </div>
    </div>
    <ToBack/>
  </div>
</template>

<script>
import http from '../common/http.js'
import ToBack from './common/toback.vue'
export default { 
  components: {
    ToBack
  },
  data() {
    return {
      productMsg: '',
      id: this.$route.query.id || '',
      productDetails: false
    };
  },
  mounted() {
    this.getDel()
  },
  methods: {
    getDel() {
      http.get('/goods/public/goods_detail?goodsId=' + this.id).then(res => {
        this.productDetails = true
        this.productMsg = res
      })
    }
  }
};
</script>

<style lang="less" scoped>
.graphic-details {
  padding: 0 15px 15px;
  /deep/ .graphic-info {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .no-msg {
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-align: center;
    line-height: 3.6;
    img {
      width: 100%;
    }
  }
}
</style>